<template>
  <a-form-item label="Город" name="city_id">
    <a-select
        v-model:value="cityId"
        show-search
        allow-clear
        :filter-option="false"
        :options="options"
        :loading="loading"
        :not-found-content="loading ? 'Загрузка…' : 'Ничего не найдено'"
        :placeholder="'Введите город'"
        @search="onSearch"
        @change="onChange"
    />
  </a-form-item>
</template>

<script>
import { ref } from "vue";
import {useStore} from "vuex";
import {computed} from "@vue/reactivity";
import {onBeforeMount} from "@vue/runtime-core";

export default {
  emits: ['changeCity'],
  props: {
    currentCity: [],
  },
  setup(props, context) {
    const cityId = ref(null);
    const options = ref([]);
    const loading = ref(false);
    const store = useStore();
    const foundCities = computed(() => store.state.foundCities);

    let timeout = null;

    const onSearch = (value) => {
      clearTimeout(timeout);

      if (!value || value.length < 3) {
        options.value = [];
        loading.value = false;
        return;
      }

      timeout = setTimeout(() => fetchCities(value), 500);
    }

    const fetchCities = (term) => {
      loading.value = true;

      store.dispatch('searchCities', term).then(() => {
        options.value = Object.entries(foundCities.value).map(([id, text]) => ({
          value: id,
          label: text,
        }));
      }).finally(() => {
        loading.value =false;
      })
    }

    const onChange = (value) => {
      context.emit("changeCity", value);
    }

    onBeforeMount(() => {
      if (props.currentCity) {
        options.value = [{
          label: props.currentCity.name ?? '',
          value: props.currentCity.id ?? null,
        }];
        cityId.value = props.currentCity.id;
      }
    })

    return {
      fetchCities,
      onChange,
      loading,
      cityId,
      options,
      onSearch
    }
  }
}
</script>